<div class="flex flex-col">
  <p
    class="mb-1 text-lg font-medium xl:mb-2"
    [innerHTML]="'page.dashboard.how-would-you-like-to-build-your-chart' | translate"
  ></p>

  <p class="text-sm text-text-2 md:text-base">
    {{ 'page.dashboard.choose-a-method-below-or-tell-us-what-you-sell-and-we-ll-highlight-the-best-fit' | translate }}
  </p>

  <div
    class="category-container mb-2 mt-4 flex flex-wrap items-center rounded-2xl border border-border-3 bg-white px-8 py-3 shadow-md"
  >
    <span class="text-15 text-text-2">{{ 'page.dashboard.what-are-you-selling' | translate }}</span>

    <div class="h-ful mx-6 w-px self-stretch bg-black/10"></div>

    <mat-button-toggle-group [value]="productCategory()">
      @for (item of productCategories; track item.value) {
        <mat-button-toggle [value]="item.value" (click)="onSelectProductCategory(item.value)">
          {{ item.label | translate }}
        </mat-button-toggle>
      }
    </mat-button-toggle-group>
  </div>

  <div class="mt-5 grid w-full grid-cols-1 gap-1 sm:grid-cols-2 sm:gap-2 md:gap-5">
    <button
      class="group h-full w-full grow rounded-2xl border border-border-3 bg-white px-6 py-4 transition-all hover:border-primary"
      style="display: inherit"
      [ngClass]="[
        notify() ? 'overflow-hidden ring ring-primary' : 'shadow-md',
        hightlighting() && !(hightlighting() ?? []).includes(0) ? 'opacity-50' : '',
        hightlighting() && (hightlighting() ?? []).includes(0) ? 'border-primary !bg-surface' : '',
      ]"
      data-cy="create-table-chart"
      (click)="onCreateTableChart()"
      [disabled]="loading()"
    >
      <div class="flex flex-col items-start justify-end">
        <div class="mx-auto my-2 xl:my-4">
          <img
            src="/assets/table-chart.webp"
            [alt]="'page.dashboard.table-style-chart' | translate"
            class="h-[135px] xl:h-[200px]"
          />
        </div>

        <h3 class="mt-auto text-left">
          <span class="font-bold text-black">
            {{ 'page.dashboard.table-style-chart' | translate }}
          </span>
          <span class="text-xs text-gray-400">({{ 'page.dashboard.excel-like' | translate }})</span>
        </h3>

        <p class="mt-1 text-xs text-primary">&#x2022; {{ 'page.dashboard.used-by-1000-merchants' | translate }}</p>

        <p class="my-2 text-left text-xs leading-normal text-text-6 xl:text-sm">
          {{
            'page.dashboard.build-a-fully-custom-grid-with-complete-control-over-every-row-column-and-measurement-unit-best-for-complex-sizing-across-multiple-regions'
              | translate
          }}
        </p>

        <div
          class="flex w-full items-center justify-center gap-x-2 p-2 text-xs font-bold text-primary transition-all group-hover:bg-primary group-hover:text-white"
        >
          <span>
            {{
              loading()
                ? ('page.dashboard.creating' | translate) + '...'
                : ('page.dashboard.create-table-chart' | translate)
            }}
          </span>

          <ng-icon size="18" name="featherChevronRight" />
        </div>
      </div>
    </button>

    <button
      class="group h-full w-full grow rounded-2xl border border-border-3 bg-white px-6 py-4 transition-all hover:border-primary"
      style="display: inherit"
      [ngClass]="[
        notify() ? 'overflow-hidden ring ring-primary' : 'shadow-md',
        hightlighting() && !(hightlighting() ?? []).includes(1) ? 'opacity-50' : '',
        hightlighting() && (hightlighting() ?? []).includes(1) ? 'border-primary !bg-surface' : '',
      ]"
      [routerLink]="ProductRoute"
      [disabled]="loading()"
    >
      <div class="flex flex-col items-start justify-end">
        <div class="mx-auto my-2 xl:my-4">
          <img
            src="/assets/product-chart.webp"
            [alt]="'page.dashboard.create-from-product' | translate"
            class="h-[135px] xl:h-[200px]"
          />
        </div>
        <h3 class="mt-auto text-left">
          <span class="font-bold text-black">
            {{ 'page.dashboard.create-from-product' | translate }}
          </span>
          <span class="text-xs text-gray-400">({{ 'page.dashboard.auto-generated' | translate }})</span>
        </h3>

        <p class="mt-1 text-xs text-primary">&#x2022; {{ 'page.dashboard.fastest-setup-2-min' | translate }}</p>

        <p class="my-2 text-left text-xs leading-normal text-text-6 xl:text-sm">
          {{
            'page.dashboard.auto-generate-a-matching-size-chart-directly-from-your-existing-shopify-variant-data-no-manual-entry-it-reads-your-product-and-fills-the-table-for-you'
              | translate
          }}
        </p>

        <div
          class="flex w-full items-center justify-center gap-x-2 p-2 text-xs font-bold text-primary transition-all group-hover:bg-primary group-hover:text-white"
        >
          <span> {{ 'page.dashboard.create-from-product' | translate }} </span>

          <ng-icon size="18" name="featherChevronRight" />
        </div>
      </div>
    </button>

    <!-- <app-upload-chart-image
      (createCategory)="onCategoryCreated($event)"
      (startUpload)="loading.set(true)"
      (error)="loading.set(false)"
    >
      <ng-template #content let-onStartUpload="onStartUpload">
        <button
          class="group h-full w-full grow rounded-2xl border border-border-3 bg-white px-6 py-4 transition-all hover:border-primary"
          style="display: inherit"
          [ngClass]="[
            notify() ? 'overflow-hidden ring ring-primary' : 'shadow-md',
            hightlighting() && !(hightlighting() ?? []).includes(2) ? 'opacity-50' : '',
            hightlighting() && (hightlighting() ?? []).includes(2) ? 'border-primary !bg-surface' : '',
          ]"
          (click)="onStartUpload()"
          [disabled]="loading()"
        >
          <div class="flex flex-col items-start justify-end">
            <div class="mx-auto my-2 xl:my-4">
              <img
                src="/assets/visual-chart.webp"
                [alt]="'common.visual-measurement-builder' | translate"
                class="h-[135px] xl:h-[200px]"
              />
            </div>

            <h3 class="mt-auto text-left">
              <span class="font-bold text-black">
                {{ 'common.visual-measurement-builder' | translate }}
              </span>
              <span class="text-xs text-gray-400">({{ 'page.dashboard.annotate-on-image' | translate }})</span>
            </h3>

            <p class="mt-1 text-xs text-primary">
              &#x2022; {{ 'page.dashboard.drag-drop-no-data-needed-upfront' | translate }}
            </p>

            <p class="my-2 text-left text-xs leading-normal text-text-6 xl:text-sm">
              {{
                'page.dashboard.upload-any-product-image-and-annotate-measurements-directly-on-it-with-drag-drop-pins-ideal-for-shoes-bags-accessories-and-equipment'
                  | translate
              }}
            </p>

            <div
              class="mt-auto flex w-full items-center justify-center gap-x-2 p-2 text-xs font-bold text-primary transition-all group-hover:bg-primary group-hover:text-white"
            >
              <span>
                {{
                  loading()
                    ? ('page.dashboard.creating' | translate) + '...'
                    : ('page.dashboard.create-with-drag-drop' | translate)
                }}
              </span>

              <ng-icon size="18" name="featherChevronRight" />
            </div>
          </div>
        </button>
      </ng-template>
    </app-upload-chart-image> -->

    <button
      [ngClass]="[
        'group flex h-fit grow gap-5 rounded-2xl transition-all hover:text-primary',
        notify() ? 'overflow-hidden ring ring-primary' : '',
      ]"
      (click)="openCtaDialog()"
      [disabled]="loading()"
    >
      <div class="shrink-0">
        <mat-icon>chevron_right</mat-icon>
      </div>

      <div class="flex flex-col gap-1">
        <h3 class="text-left font-bold text-black group-hover:text-primary">
          {{ 'page.dashboard.start-from-template' | translate }}
        </h3>

        <p class="my-2 text-left text-xs leading-normal text-text-6 group-hover:text-primary xl:text-sm">
          {{
            'page.dashboard.pick-from-ready-made-templates-for-tops-bottoms-shoes-belts-bags-and-more-customise-any-field-after-great-for-getting-started-in-under-a-minute'
              | translate
          }}
        </p>
      </div>
    </button>
  </div>
</div>
